/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("ServiceTabs", ["jquery", "Behaviors"], factory);
    } else {
        root.ServiceTabs = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function ServiceTabs() {
        Behaviors.init(ServiceTabs, this, arguments);

        
        var tabItem = this.$elem.find(ServiceTabs.ELEMENTS.ServiceTabLink);
        var tabContent = this.$elem.find(ServiceTabs.ELEMENTS.ServiceTabContainer);

        var mobileDropdown = this.$elem.find(ServiceTabs.ELEMENTS.ServiceMobileDropdown);

        //URL Feature Update - Aleks START
        // if(window.location.hash.length > 0) {
        //     var hash = window.location.hash.slice(1)
        //     console.log(window.location.hash);
        //     // titleString = title.replace(/-/g, ' ').toUpperCase();
        //     $('[data-tab-slug=#' + hash + ']').addClass('active');
        //     $('[data-tab-content=' + hash + ']').addClass('active');
        //     // $(".TabbedAccordion-placeholder_tab span").text(titleString);
        // } else {
        //     $(".tab-wrapper .ServiceTabs-tab-nav:first-child .tab-btn").addClass('active');
        //     $(".tab-content-wrapper .ServiceTabs-tab-content:first-child").addClass("active");
        // }
        
        //URL Feature Update - Aleks END

        //URL Feature Update - Aleks START
        //New update for new slug logic
        $(".tab-wrapper .ServiceTabs-tab-nav:first-child .tab-btn").addClass('active');
        $(".tab-content-wrapper .ServiceTabs-tab-content:first-child").addClass("active");
        //URL Feature Update - Aleks END

        mobileDropdown.on('change',function(e){
            e.preventDefault();
            var target = this.value.replace('#','');
            updateTabContent(target);
        });

        
        tabItem.on('click', function(e) {
            e.preventDefault();
            // var target = this.getAttribute('href').replace('#','');
            //URL Feature Update - Aleks START
            //New update for new slug logic
            var target = this.getAttribute('data-tab-slug').replace('#','');
            //URL Feature Update - Aleks END
            updateTabContent(target);
            this.classList.add('active');

            //URL Feature Update - Aleks START
            //Define active tab item
            // var activeTabItem = $(this).data('tab-slug');
            // //Define URL var
            // var urlParameters = '';
            // //Define item in the URL
            // if (activeTabItem.length > 0) {
            //     urlParameters +=  activeTabItem;
            // }
            // //Define URL behaviour
            // urlParameters = urlParameters ? urlParameters : '';
            // if (urlParameters.length > 0) {
            //     history.replaceState(undefined, undefined, urlParameters);
            // } else {
            //     history.replaceState(undefined, undefined, '#');
            // }
            //URL Feature Update - Aleks END
        })
        
    }

    function updateTabContent(target){
        var tabs = document.querySelectorAll( ServiceTabs.ELEMENTS.ServiceTabLink );
        var containers = document.querySelectorAll( ServiceTabs.ELEMENTS.ServiceTabContainer );
        tabs.forEach( el => {
            if(el.classList.contains('active')){
                el.classList.remove('active'); 
            }
        });

        containers.forEach( el => {
            if(el.classList.contains('active')){
                el.classList.remove('active'); 
            }
        });
        document.getElementById(target).classList.add('active');
    }

    Behaviors.inherit(ServiceTabs, Behaviors.Behavior);
    ServiceTabs.QUERY = "[data-service-tabs]";

    ServiceTabs.ELEMENTS = {
        ServiceTabLink: ".tab-btn",
        ServiceTabContainer: ".service-container",
        ServiceMobileDropdown: ".mobile-dropdown"
    };
    
    Behaviors.register_behavior(ServiceTabs);

    module.ServiceTabs = ServiceTabs;

    return module;
}));
